// extracted by mini-css-extract-plugin
module.exports = {"Container":"Carousel_Container__3V6rm","Carousel":"Carousel_Carousel__2pMnk","BackgroundImage":"Carousel_BackgroundImage__2X4ba","Content":"Carousel_Content__1qOAC"};